/**
 * FileName : index.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-07-03 19:42:41
 * Description :
 * -----
 * Last Modified: 2024-08-08 15:16:47
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */

import { lazy } from 'react';
import { RouterConfig } from '../../types';

export const MDRHomePageRouterConfig: RouterConfig[] = [
    {
        key: 'Home',
        title: 'menuTitleMdrMain',
        route: '/home/HomePage',
        icon: 'HomeMenuSVG',
        component: lazy(() => import('src/pages/homePage')),
    },
];
